var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"confirm-module-price-text"},[_c('base-price-text',{attrs:{"price":_vm.price,"styleOption":{
      currency: 'font-size: 14px;line-height:16px;margin-right: 2px;',
      integer: 'font-size: 20px;line-height:19px;',
      decimal: 'font-size: 16px;',
    }},scopedSlots:_vm._u([{key:"right",fn:function(){return [_c('span',{staticStyle:{"font-size":"12px","line-height":"16px","margin-left":"4px","font-weight":"400"}},[_vm._v("/人")]),_c('span',{staticStyle:{"color":"#5F666E","font-size":"12px","line-height":"16px","margin-left":"4px","font-weight":"400"}},[_vm._v(" x "+_vm._s(_vm.length))])]},proxy:true}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-440009d2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ordering/components/base/confirm-module-price-text.vue
// module id = null
// module chunks = 